import React from "react";
import { DPComponentLoader, DPEmptyTable, DPTable } from "Components/DP";
import { usePartnerConfig } from "Hooks/usePartnerConfig";
import { useEmployeeProfileQuery } from "Hooks/useEmployeeProfileQueryContext";
import { DPEmployeeeReward } from "Shared/types/Rewards";
import { EmployeeRewardsTableRow } from "./EmployeeRewardsTableRow/EmployeeRewardsTableRow";
import pretty from "Shared/pretty";
import useStyles from "./styles";
import { Header } from "Components/DP/DPTable/DPTable";

const HEADERS = [
  "Date/Time",
  "Requestor name",
  "Reward Amount",
  "Reward Status",
  "Secondary Approver",
  "Reason",
  { label: "Action", align: "center" },
] as Header[];

export interface EmployeeRewardsTableProps {
  page: number;
  perPage: number;
  employeeRewards: {
    totalCount: number;
    items: DPEmployeeeReward[];
  } | undefined;
  loading: boolean;
  onChangePage: (
    evt: React.MouseEvent<HTMLButtonElement, MouseEvent> | null,
    newPage: number
  ) => void;
}

export const EmployeeRewardsTable = ({
  employeeRewards,
  loading,
  page,
  perPage,
  onChangePage,
}: EmployeeRewardsTableProps) => {
  const classes = useStyles();
  const { employer } = usePartnerConfig();
  const { userDetails } = useEmployeeProfileQuery();
  const employeeFullName = pretty.fullName(
    userDetails?.employee.firstName || "",
    userDetails?.employee.lastName || ""
  );

  return (
    <DPTable
      count={employeeRewards?.totalCount}
      headers={HEADERS}
      loading={loading}
      onChangePage={onChangePage}
      page={page}
      rowsPerPage={perPage}
      className={classes.table}
    >
      <DPComponentLoader
        isLoading={loading}
        kind={"table"}
        awaitComponent={
          employeeRewards?.totalCount ? (
            <>
              {employeeRewards.items.map(reward => (
                <EmployeeRewardsTableRow
                  key={reward.id}
                  reward={reward}
                  employeeFullName={employeeFullName}
                  employerId={employer.id}
                />
              ))}
            </>
          ) : (
            <DPEmptyTable message={"Employee Rewards will appear here"} />
          )
        }
      />
    </DPTable>
  );
};
